module.exports = __webpack_public_path__ + "static/media/03.0.Stage View.f6852084.JPG";